/**
 * ADRE Online Licensing System Web API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * Start payment request type
 */
export class StartPaymentRequestModel { 
    /**
     * ADRE WorkflowID returned in StarFunction service
     */
    workflowID: number;
    /**
     * The current step in the workflow from the UI perspective used for validation purposes
     */
    currentStepIndex: number;
    /**
     * The Application Return URL to provide SCS after payment. Generate an encrypted token to protect state
     */
    scsReturnToApplicationUrl: string;
}



// WEBPACK FOOTER //
// ./src/app/model/startPaymentRequestModel.ts